(function () {

    var appDependencies = ['ngSanitize', 'ea.translation', 'eventact.ui.utils', 'ea.inputs', 'ea.storage'];

    if (_addedDependencies.length > 0) {
        appDependencies = appDependencies.concat(_addedDependencies);
    }

    angular.module("EventListApp", appDependencies)
        .config(['$sceDelegateProvider', function ($sceDelegateProvider) {
            $sceDelegateProvider.resourceUrlWhitelist([
                // Allow same origin resource loads.
                'self',
                'https://static.eventact.com/**',
                'https://program.eventact.com/**',
            ]);

            // The blacklist overrides the whitelist so the open redirect here is blocked.
            $sceDelegateProvider.resourceUrlBlacklist([
            ]);
        }])
        .run(['$translation', 'SharedData', run])
        .directive('renderEnds', function () {
            return {
                restrict: "A",
                link: function (scope, element, attrs) {
                    if (scope.$last) {
                        scope.$eval(attrs.renderEnds);
                    }
                }
            }
        })
        .directive('enlargable', function () {
            return {
                restrict: "A",
                link: function (scope, element, attrs) {
                    element.click(function () {
                        var src = $(element).attr('src');
                        var el = document.getElementById('full-gallery');
                        if (el) // remove previous element
                            el.remove();

                        $('<div id="full-gallery">').css({
                            background: 'RGBA(0,0,0,.5) url(' + src + ') no-repeat center',
                            backgroundSize: 'contain',
                            width: '100%',
                            height: '100%',
                            position: 'fixed',
                            zIndex: '10000',
                            top: '0',
                            left: '0',
                            cursor: 'zoom-out'
                        }).click(function () {
                            $(this).remove();
                        }).appendTo('body');
                    });
                }
            }
        })
        .filter('slotsGroupByDay', function () {
            function getDate(day) {
                if (!day) return '';
                return new moment.utc(parseInt(day)).format("MMMM Do, YYYY");
            }

            return function (input, count) {
                var out = [];
                var groupItemsPerRow = count != undefined && count > 0;
                var dictionaryIndices = {};
                var dayIndex = -1;
                if (typeof input === "object") {
                    for (var i = 0, j = input.length; i < j; i++) {
                        var key = getDate(input[i].fullDate);
                        if (dictionaryIndices[key] === undefined) {
                            dayIndex++;
                            dictionaryIndices[key] = dayIndex;
                            out[dayIndex] = { day: key, slots: [] };
                        }

                        if (groupItemsPerRow) {
                            if (out[dayIndex].slots.length == 0)
                                out[dayIndex].slots.push([]);

                            var splitIndex = out[dayIndex].slots.length - 1;
                            if (out[dayIndex].slots[splitIndex].length == count) {
                                out[dayIndex].slots.push([]);
                                splitIndex++;
                            }
                            out[dayIndex].slots[splitIndex].push(input[i]);
                        }
                        else
                            out[dayIndex].slots.push(input[i]);
                    }
                }
                return out;
            }
        });

    function run($translation, sharedData) {
        sharedData.Init();

        var enTranslation = {
            'booth': 'Booth {0}',
            'exhibitorError': 'Cannot schedule a meeting',
            'participantError': 'Cannot schedule a meeting with exhibitor',
            'mainExhibitorError': 'Cannot schedule a meeting with exhibitor representative',
            'scheduleError': 'Can not schedule a meeting',
            'noTimes': 'No time slots are currently available in the system.',
            'preferredTimes': 'Select the time of the meeting',
            'incorrectData': 'Incorrect data',
            'smsNotEnabled': 'SMS password reminder mode was not enabled',
            'smsPasswordFailed': 'Password reminder by SMS is not currently possible',
            'nextBtn': 'Next »',
            'accountNotFound': 'Please <a href="{0}">register</a> to the event to schedule meetings',
            'newAccountButton': 'Create an account now',
            'verify': 'Verify',
            'recoveryLimitExceeded': 'A limit exceeded',
            'codeRequired': 'Please enter your verification code',
            'sendPasswordButtonToEmail': 'Send one - time password to my email',
            'otpEmailSuccess': "Please enter the verification code sent to {0}",
            'otpFailed': 'Failed to send verification code, please try again',
            'wrongOtp': 'Invalid verification code. Please check your email and enter code again.',
            'otpExceeded': 'You have exceeded the number of authentication recovery attempts.\n Please try again in {0} minutes.',
            'addMessage': 'Please share anything that will help prepare {0} for the meeting',
            'message': 'Message',
            'requestMeeting': 'Schedule a meeting on {0} at {1}',
            'requestMeetingBtn': 'Schedule a meeting',
            'scheduleMeeting': 'Schedule a meeting with {0}',
            "selectTime": "Select a time",
            "noPlace": "Exhibitor does not have a meeting place",
            "meetingBlocked": "You currently cannot send a message to this participant",
            'meetingScheduled': 'Meeting was scheduled successfully',
            'meetingWith': 'Your meeting with {0}',
            'exhibitorMeetingDescription': 'Meeting with {0}',
            'participantMeetingDescription': 'Meeting with {1} from {0}',
            'enterEmailPrompt': 'Please enter your email',
            'enterEmail': 'Email',
            'connect': 'Schedule a meeting',
            'otpNotRecived': "Didn't get the email?",
            'resendOTP': "Please re-send it.",
            'otpRemainingTime': " ({0} seconds remaining)",
            'meetingStaffWelcomeText': 'Make the most of your time at {0} by selecting one of the available times listed below to meet 1:1 with {1}. Meetings will be held at {2} with {1}.',
            'meetingMainWelcomeText': 'Make the most of your time at {0} by selecting one of the available times listed below to meet 1:1 with {1}. Meetings will be held at {2} with a {1} representative.',
            'duplicatedMeetingTime': "We couldn't schedule the meeting because you have another meeting scheduled at the same time",
            'exhibitorNotAvailable': "Sorry. We couldn't schedule the meeting. Please choose a different time.",
            'enterCode': "Event the code",
        };

        var heTranslation = {
            'booth': 'דוכן {0}',
            'exhibitorError': 'לא ניתן לקבוע פגישה',
            'participantError': 'לא ניתן לקבוע פגישה עם המציג',
            'mainExhibitorError': 'לא ניתן לקבוע פגישה עם נציגי המציג',
            'scheduleError': 'לא ניתן לקבוע פגישה',
            'noTimes': 'אין חלונות זמן זמינות כרגע במערכת.',
            'preferredTimes': 'בחר את שעת הפגישה',
            'incorrectData': 'נתונים שגויים',
            'smsNotEnabled': 'מצב תזכורת סיסמת SMS לא הופעל',
            'smsPasswordFailed': 'תזכורת סיסמה ב-SMS אינה אפשרית כרגע',
            'nextBtn': 'הבא »',
            'accountNotFound': 'אנא <a href="{0}">הירשם</a> לאירוע כדי לקבוע פגישות',
            'newAccountButton': 'צור חשבון עכשיו',
            'verify': 'אמת',
            'recoveryLimitExceeded': 'חרגת מגבלה',
            'codeRequired': 'אנא הזן את קוד האימות שלך',
            'sendPasswordButtonToEmail': 'שלח סיסמה חד פעמית למייל שלי',
            'otpEmailSuccess': "אנא הזן את קוד האימות שנשלח לכתובת {0}",
            'otpFailed': 'שליחת קוד האימות נכשלה, אנא נסו שוב',
            'wrongOtp': 'קוד אימות לא חוקי. אנא בדקו את האימייל והזינו שוב את הקוד.',
            'otpExceeded': 'חריגה ממספר ניסיונות שחזור האימות.\n אנא נסו שוב בעוד {0} דקות.',
            'addMessage': 'מידע שיכול לסייע להכין את {0} לפגישה',
            'message': 'הודעה',
            'requestMeeting': 'קביעת פגישה ב-{0} ב-{1}',
            'requestMeetingBtn': 'קביעת פגישה',
            'scheduleMeeting': 'קביעת פגישה עם {0}',
            "selectTime": "בחר זמן",
            "noPlace": "למציג אין מקום מפגש",
            "meetingBlocked": "כרגע אין אפשרות לשלוח הודעה למשתתף זה",
            'meetingScheduled': 'הפגישה נקבעה בהצלחה',
            'meetingWith': 'הפגישה שלך עם {0}',
            'exhibitorMeetingDescription': 'פגישה עם {0}',
            'participantMeetingDescription': 'פגישה עם {1} מ-{0}',
            'enterEmailPrompt': 'אנא הכניסו כתובת דוא"ל',
            'enterEmail': 'דוא"ל',
            'connect': 'קביעת פגישה',
            'otpNotRecived': "לא קיבלת את המייל?",
            'resendOTP': "אנא שלח אותו מחדש.",
            'otpRemainingTime': " (נותרו {0} שניות)",
            'meetingStaffWelcomeText': 'הפיקו את המירב מהזמן שלכם ב-{0}. שרינו מראש זמן לפגישה 1:1 עם {1}. פגישות יתקיימו ב-{2} עם {1}.',
            'meetingMainWelcomeText': 'הפיקו את המירב מהזמן שלכם ב-{0}. שרינו מראש זמן לפגישה 1:1 עם {1}. פגישות יתקיימו ב-{2} עם נציג {1}.',
            'duplicatedMeetingTime': "לא הצלחנו לתזמן את הפגישה כי יש לך פגישה נוספת מתוכננת באותו הזמן",
            'exhibitorNotAvailable': "מצטערים. לא יכולנו לקבוע את הפגישה. נא לבחור זמן אחר.",
            'enterCode': "הזינו את הקוד",
        };

        var lang = document.documentElement.lang || 'en';
        $translation
            .addTranslation('en', enTranslation)
            .addTranslation('he', heTranslation)
            .useLang(lang);
    }

    /**
     * Bootstraps Angular only on elements marked data-ea-ng-root (outermost ones; nested roots are compiled by their parent).
     * Server-rendered user content outside these roots is never compiled, so it can't be used for Angular template injection.
     */
    angular.element(function () {
        document.querySelectorAll('[data-ea-ng-root]').forEach(function (root) {
            if (root.parentElement && root.parentElement.closest('[data-ea-ng-root]'))
                return;

            angular.bootstrap(root, ['EventListApp']);
        });
    });


    //var parts = window.location.pathname.split('/');
    //var eventCode = parts[0];
    //if (eventCode == '')
    //    eventCode = parts[1];

    //var myDynamicManifest = {
    //    "short_name": eventCode,
    //    "name": eventCode,
    //    "prefer_related_applications": false,
    //    "background_color": "#f5f5f5",
    //    "theme_color": "#3FA9F5",
    //    "display": "standalone",
    //    "start_url": getAppUrl() + eventCode,
    //    "orientation": "portrait",
    //    "icons": [
    //        {
    //            "src": "https://static.eventact.com/imgs/eva/eva192.png",
    //            "type": "image/png",
    //            "sizes": "192x192"
    //        },
    //        {
    //            "src": "https://static.eventact.com/imgs/eva/eva512.png",
    //            "type": "image/png",
    //            "sizes": "512x512"
    //        }
    //    ]
    //}

    //var stringManifest = JSON.stringify(myDynamicManifest);
    //var blob = new Blob([stringManifest], { type: 'application/json' });
    //var manifestURL = this.URL.createObjectURL(blob);
    //document.querySelector('#manifest-ph').setAttribute('href', manifestURL);

})()

var IsLocal = document.location.hostname === "localhost";
var PageUrl = window.location.href.split('#')[0];

function getAppUrl() {
    var url = location.protocol + "//" + location.host + "/";
    // working on server - add sub domain
    if (location.host === "beta.eventact.com") {
        url += window.location.pathname.split('/')[1] + "/";
    }

    if (url[url.length - 1] != '/')
        url = url + "/"
    return url;
}